import $ from "jquery"
import { startupMailform } from "./parts/startup"
import { falsesubmit, mfp_disp } from "./parts/globalFunctions"
import _ from "./utils/lodash"
import { sendMail, mfp_reset } from "./parts/sendmail"
import { inputTyping } from "./parts/inputTyping"
import { mfpc } from "./parts/postalcodes"
;((w, d, $) => {
  _.assign(w, {
    falsesubmit,
    sendMail,
    mfp_reset,
    mfpc,
    mfp_disp,
    inputTyping,
  })
  $(() => {
    startupMailform(w, d)
  })
})(window, window.document, $)
